import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {MenuItem, LazyLoadEvent,} from 'primeng/api';
import {ApplicationClaimTypesService, UserClaimService} from '../../../services';
import { IGlobalSearchParam, ISearchGlobalFilter } from '../../../../shared/models/Global-Search.model';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../../../shared/services/shared.service';
import { Router, ActivatedRoute } from '@angular/router';

import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';

@Component({
  selector: 'app-user-claims',
  templateUrl: './user-claims.component.html',
  styleUrls: ['./user-claims.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class UserClaimsComponent implements OnInit {
  user: any;
  loading: boolean = false;
  companyName: any = [];
  searchForm: FormGroup;
  userRole: any = [];
  isUserList: boolean = false;
  userClaim: any;
  userPermissionsLoading: boolean =false;
  isUserPermission: boolean = false;
  userProfileId: number;
  userProfileUserName: string = "";
  dialogPosition = 'topright';
  selectedGridMenuItem:any = null;
  items: MenuItem[];
  constructor(private userClaimService:UserClaimService,  private _fb: FormBuilder,
    public sharedService:SharedService,
    private _router: Router
    ) { 
    this.InitialSetup();
    this.items = [
     
      {
       label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.userPermission(this.selectedGridMenuItem.userProfileId,this.selectedGridMenuItem.userName)
      }
   ];
  }

  InitialSetup(){
    this.companyName.push({ "companyId": 0, "companyName": "All" });
    this.userRole.push({ "id": "0", "name": "All" })
    this.searchForm = this._fb.group({
      companyName: new FormControl(0),
      userRole: new FormControl(0),
      userName: new FormControl()
    })
  }
  ngOnInit(): void {
    //this.checkViewPermission();
    this.getCompanyName();
  }

  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }

  userPermission(userProfileId, userName) {
    this.userProfileId = userProfileId;
    this.userProfileUserName = userName;
    this.isUserPermission = true;
    this.userPermissionsLoading = true;
    this.userClaimService.getUserClaimByUserProfileId(userProfileId).subscribe(data => {
      this.userClaim = data;
      this.userPermissionsLoading = false;
    }, error => {
      console.log(error);
    })
  }

  getCompanyName(){
    this.userClaimService.getCompanyName().subscribe(data => {
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          this.companyName.push(data[i])
        }
      }
    },
    error=>{
      console.log(error);
    })
  }

  companyNameOnChange(companyId){
    this.userRole = [];
    this.userRole.push({ "id": "0", "name": "All" })
    this.searchForm.patchValue({"userRole": "0"});
    this.getUserRole(companyId);
  }

  getUserRole(companyId){
    this.userClaimService.getUserRole(companyId).subscribe(data => {
      this.userRole = [];
      this.userRole.push({ "id": "0", "name": "All" })
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          this.userRole.push(data[i])
        }
      }
    },
    error =>{
      console.log(error);
    })
  }

  search(){
    this.isUserList = true;
    this.loading = true;
    this.isUserPermission = false;
    let companyId = this.searchForm.get('companyName').value;
    let userRoleId = this.searchForm.get('userRole').value;
    let userName = this.searchForm.get('userName').value;
    this.userClaimService.getUserList(companyId,userRoleId,userName).subscribe(data => {
      this.user = data;
      this.loading = false;
    }, error => {
      console.log(error)
    })
  }
  
  saveClaim() {
    this.userPermissionsLoading = true;
    var arrFinalData = [];
    for (var i = 0; i < this.userClaim.length; i++) {
      for (var j = 0; j < this.userClaim[i].claimTypeView.length; j++) {
        var tempUserClaim = {};
        tempUserClaim['userClaimId'] = 0;
        tempUserClaim['userId'] = null;
        tempUserClaim['userProfileId'] = this.userProfileId;
        tempUserClaim['claimMasterId'] = null;
        tempUserClaim['featureId'] = this.userClaim[i].featureId;
        tempUserClaim['featureName'] = this.userClaim[i].featureName;
        tempUserClaim['claimTypeId'] = this.userClaim[i].claimTypeView[j].claimTypeId;
        tempUserClaim['claimType'] = this.userClaim[i].claimTypeView[j].claimType;
        tempUserClaim['hasPermission'] = this.userClaim[i].claimTypeView[j].hasPermission;
        tempUserClaim['isActive'] = true;
        tempUserClaim['createdBy'] = 1;
        tempUserClaim['createdOn'] = "2021-09-10T00:00:00";
        tempUserClaim['modifiedBy'] = null;
        tempUserClaim['modifiedOn'] = null;
        arrFinalData.push(tempUserClaim);
      }
    }
    var body = {
      "userProfileId": this.userProfileId,
      "userId": null,
      "applicationFeatures": null,
      "applicationClaimTypes": null,
      "userClaimsMasterView": null,
      "userClaimViewGrid": arrFinalData
    }
    this.userClaimService.postUserClaims(body).subscribe(data => {
      this.isUserPermission = false;
      this.userPermissionsLoading = false;
      console.log(data);
    }, error => {
      console.log(error);
    })
  }

  cancelClaim(){
    this.isUserPermission = false;
  }
}
